import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { BracketLink } from "./atoms";

const LINKS = [
  { href: "#issues", label: "Key Issues" },
  { href: "#answers", label: "Answers" },
  { href: "#prototype", label: "Prototype" },
  { href: "#mockups", label: "Mockups" },
  { href: "#estimate", label: "Estimate" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="proposal-nav"
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-300 ${scrolled ? "bg-bone/90 backdrop-blur-xl border-b border-linec" : "bg-transparent"}`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <Logo />
        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <a key={l.href} href={l.href} data-testid={`nav-link-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className="font-body text-sm text-navy/75 hover:text-ember transition-colors">
              {l.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-4">
          <BracketLink to="/letter" testid="nav-print-link">Print Proposal</BracketLink>
        </div>
      </div>
    </header>
  );
}
